<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人" v-trim/>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入编辑人" v-trim/>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="form.info" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="类型 0订阅 1发布" prop="type">
        <el-input v-model="form.type" placeholder="请输入类型 0订阅 1发布" v-trim/>
      </el-form-item>
      <el-form-item label="客户端编码" prop="clientid">
        <el-input v-model="form.clientid" placeholder="请输入客户端编码" v-trim/>
      </el-form-item>
      <el-form-item label="主题" prop="topic">
        <el-input v-model="form.topic" placeholder="请输入主题" v-trim/>
      </el-form-item>
      <el-form-item label="消息内容" prop="msg">
        <el-input v-model="form.msg" placeholder="请输入消息内容" v-trim/>
      </el-form-item>
      <el-form-item label="结果 0成功 1失败" prop="result">
        <el-input v-model="form.result" placeholder="请输入结果 0成功 1失败" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaMqttLogWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        info: '',
        type: '',
        clientid: '',
        topic: '',
        msg: '',
        result: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/mqttLog',
      'field.id': 'id'
    })
  }
}
</script>
